import ComponentDescription from "components/customs/ComponentDescription";
import ComponentFooter from "components/cms/ComponentHeader";
import { FooterDefinitions } from "./FooterDefinitions";

export class Footer extends FooterDefinitions {
    render() {
        const { className, designing } = this.props;

        return (
            <div
                data-schema-id={this.props.id}
                className={["fa-Footer fa-draggable", designing && "designing", className]
                    .filter((e) => !!e)
                    .join(" ")}
            >
                {designing && (
                    <ComponentFooter
                        componentEntry={this.props.entry}
                        componentSchemaId={this.props.id as string}
                    />
                )}
                <ComponentDescription
                    node={this.props.schemaNode}
                    entry={this.props.entry}
                />
            </div>
        );
    }
}
